// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-header .header-content {
  width: 100%;
  display: flex;
}

.site-header .right {
  display: flex;
  margin-left: auto !important;
}

.main-layout,
#authenticated-app,
.pusher,
.ui.site-content {
  height: 100dvh;
}
`, "",{"version":3,"sources":["webpack://./src/components/main/style.common.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;;;;EAIE,cAAc;AAChB","sourcesContent":[".site-header .header-content {\r\n  width: 100%;\r\n  display: flex;\r\n}\r\n\r\n.site-header .right {\r\n  display: flex;\r\n  margin-left: auto !important;\r\n}\r\n\r\n.main-layout,\r\n#authenticated-app,\r\n.pusher,\r\n.ui.site-content {\r\n  height: 100dvh;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
